import { useParams, useNavigate } from 'react-router-dom'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

import { Icon, Breadcrumb } from '@/ui'
import { splitTaxYearQuarter } from '../../helpers'
import { useReselector } from '@/utils/sharedHooks'
import { selectTaxCalculationByTaxQuarter } from '@/selectors/userTaxCalculation.selectors'
import EstimateBreakdownV3 from './EstimateBreakdownV3'

// TODO: Migrate to V2
import { selectQuarterlyTaxEstimateDetailsByYearAndQuarter } from '@/featuresV1/Admin/QuarterlyTaxEstimateDetails/quarterlyTaxEstimateDetails.selector'

export const EstimateBreakdownV3Wrapper = () => {
  const { taxQuarter } = useParams()
  const navigate = useNavigate()
  const { quarter, year } = splitTaxYearQuarter(taxQuarter)

  const taxCalc = useReselector(selectTaxCalculationByTaxQuarter, taxQuarter)
  const estimateDetails = useReselector(
    selectQuarterlyTaxEstimateDetailsByYearAndQuarter,
    year,
    quarter
  )

  return (
    <div className="mx-2 sm:mx-0 flex flex-col gap-4">
      <Breadcrumb>
        <Breadcrumb.List>
          <Breadcrumb.Item>
            <Breadcrumb.Link
              onClick={() => {
                navigate('/taxes/quarterly')
              }}
            >
              <Icon icon={regular('arrow-left')} className="mr-2" />
              Back to Quarterly Taxes
            </Breadcrumb.Link>
          </Breadcrumb.Item>
        </Breadcrumb.List>
      </Breadcrumb>
      <EstimateBreakdownV3
        taxCalc={taxCalc}
        estimateDetails={estimateDetails}
      />
    </div>
  )
}
